<template>
  <LoginView/>
  <!-- start orders -->
  <section id="orders" v-if="global.authenticated">
    <div class="overlay">
      <div class="container">
        <div class="d-flex align-items-start flex-column justify-content-center">

          <h4>Режим администратора для добавления заказов по телефону</h4>
          <br/>

          <booking-widget-admin></booking-widget-admin>
          <br/>
          <h4>Поиск заказов</h4>
          <div class="order-filter">
            <div class="order-filter-cell">
              Статус:&nbsp;
              <select class="order-filter-input" v-model="ordersFilter.state" @change="loadOrders">
                <option value="-1">Все</option>
                <option value="0">Новые</option>
                <option value="1">Подтвержденные</option>
                <option value="2">Отмененные</option>
              </select>
            </div>
            <div class="order-filter-cell">
              Дата:&nbsp;
              <input class="order-filter-input" type="date" v-model="ordersFilter.date" @change="loadOrders"/>
            </div>
            <div class="order-filter-cell">
              Клиент/телефон:&nbsp;
              <input class="order-filter-input" type="text" v-model="ordersFilter.text" @input="loadOrders"/>
            </div>
            <div class="order-filter-cell">

            </div>
          </div>
          <br/>

          <table class="order-table">
            <tr>
              <td className="header-cell">Клиент</td>
              <td className="header-cell">Комментарий</td>
              <td className="header-cell">Источник</td>
              <td className="header-cell">Номер</td>
              <td className="header-cell">Дата</td>
              <td v-if="global.account.mode==2" className="header-cell">Сумма</td>
              <td className="header-cell">Статус</td>
              <td className="header-cell">Действия</td>
            </tr>
            <tr v-if="orders.length==0">
              <td className="cell" colspan=6 style="text-align: center;">Нет данных
            </td>
          </tr>
          <tr v-for="(order) in orders"
          :key="order.id">
          <td className="cell">{{order.customer}} ({{order.phone}})</td>
          <td className="cell">{{order.comment}}</td>
          <td className="cell">{{order.channel}}</td>
          <td className="cell">{{order.subjectName}}</td>
          <td className="cell">{{order.dateText}}</td>
          <td v-if="global.account.mode==2" className="cell">{{order.pay}}</td>
          <td className="cell">{{order.state == 0 ? "Новый" : order.state == 1 ? "Подтвержден" : "Отменен"}}</td>
          <td className="cell">
            <input v-if="order.state!=1" @click="order.showActionModal2 = true" type="button"
            class="btn btn-sm btn-success text-uppercase" value="Подтвердить">
            <input v-if="order.state!=2" @click="order.showActionModal = true" type="button"
            class="btn btn-sm btn-danger text-uppercase" value="Отменить">
            <input v-if="order.payConfirmed==true" @click="order.showActionModal3 = true" type="button"
            class="btn btn-sm btn-danger text-uppercase" value="Вернуть оплату">

            <input v-if="order.payUri!=null" @click="order.showModal = true" type="button"
            class="btn btn-sm btn-success text-uppercase" value="Показать ссылку">

            <ModalDialog
            :title="'Ссылка на оплату'"
            :message=order.payUri
            :isVisible=order.showModal
            @close="order.showModal = false"
            />
            <ModalActionDialog
            :title="'Отменить бронирование'"
            :message="'Вы действительно хотите отменить бронирование'"
            :isVisible=order.showActionModal
            @action="setState(order.id,2)"
            @close="order.showActionModal = false"
            />
            <ModalActionDialog
            :title="'Отменить бронирование'"
            :message="'Вы действительно хотите подтвердить бронирование'"
            :isVisible=order.showActionModal2
            @action="setState(order.id,1)"
            @close="order.showActionModal2 = false"
            />
            <ModalActionDialog
            :title="'Отменить бронирование'"
            :message="'Вы действительно хотите вернуть оплату за бронирование'"
            :isVisible=order.showActionModal3
            @action="cancelOrder(order.id)"
            @close="order.showActionModal3 = false"
            />

          </td>
        </tr>
      </table>

      <div className="order-cards">
        <div v-if="orders.length==0" className="order-card">
          <div className="order-card-cell">Нет данных</div>
        </div>
         <div v-for="(order) in orders"
        :key="order.id" class="order-card">
        <div className="order-card-cell">Клиент: {{order.customer}} ({{order.phone}})</div>
        <div className="order-card-cell">Комментарий: {{order.comment}}</div>
        <div className="order-card-cell">Источник: {{order.channel}}</div>
        <div className="order-card-cell">Номер: {{order.subjectName}}</div>
        <div className="order-card-cell">Дата: {{order.dateText}}</div>
        <div v-if="global.account.mode==2" className="order-card-cell">Сумма: {{order.pay}}</div>
        <div className="order-card-cell">Статус:
          {{order.state == 0 ? "Новый" : order.state == 1 ? "Подтвержден" : "Отменен"}}
        </div>
        <div className="order-card-cell">
          <input v-if="order.state!=1" @click="order.showActionModal2 = true" type="button"
          class="btn btn-sm btn-success text-uppercase" value="Подтвердить">
          <input v-if="order.state!=2" @click="order.showActionModal = true" type="button"
          class="btn btn-sm btn-danger text-uppercase" value="Отменить">
          <input v-if="order.payConfirmed==true" @click="order.showActionModal3 = true" type="button"
          class="btn btn-sm btn-danger text-uppercase" value="Вернуть оплату">

          <input v-if="order.payUri!=null" @click="order.showModal = true" type="button"
          class="btn btn-sm btn-success text-uppercase" value="Показать ссылку">

          <ModalDialog
          :title="'Ссылка на оплату'"
          :message=order.payUri
          :isVisible=order.showModal
          @close="order.showModal = false"
          />
          <ModalActionDialog
          :title="'Отменить бронирование'"
          :message="'Вы действительно хотите отменить бронирование'"
          :isVisible=order.showActionModal
          @action="setState(order.id,2)"
          @close="order.showActionModal = false"
          />
          <ModalActionDialog
          :title="'Отменить бронирование'"
          :message="'Вы действительно хотите подтвердить бронирование'"
          :isVisible=order.showActionModal2
          @action="setState(order.id,1)"
          @close="order.showActionModal2 = false"
          />
          <ModalActionDialog
          :title="'Отменить бронирование'"
          :message="'Вы действительно хотите вернуть оплату за бронирование'"
          :isVisible=order.showActionModal3
          @action="cancelOrder(order.id)"
          @close="order.showActionModal3 = false"
          />


        </div>
      </div>
    </div>

    <br>
      <div class="order-filter" v-if="showAddOrdersBtn">
      <div class="order-filter-cell">
            <input @click="addOrders()" type="button" class="btn btn-sm btn-success main-btn text-uppercase"
            value="Показать ещё">
          </div>
        </div>
    </div>

  </div>
</div>
</section>
<!-- end orders -->

</template>

<style>
#orders .overlay {
  background: none;
}

#orders {
  /*background: url('../images/b1.jpg') no-repeat;*/
  background-size: cover;
  text-align: center;
  /*height: calc(100% - 145px);*/
}

#orders .order-filter {
  background: #fff;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  width: 100%;
}

#orders .order-filter-cell {
  padding: 1px 16px;
  box-sizing: border-box;
  font-weight: 500;
  text-align: left;
  height: 56px;
  display: flex;
  align-items: center;
}

#orders .header-cell {
  height: 56px;
  padding: 1px 16px;
  box-sizing: border-box;
  font-weight: 500;
  text-align: left;
}

#orders .cell {
  border-top-width: 1px;
  border-top-style: solid;
  border-top-color: rgba(0, 0, 0, 0.12);
  height: 52px;
  padding: 1px 16px;
  text-align: left;
}

#orders .order-table {
  background: #fff;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
  width: 100%;
}

#orders .order-row {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
}

#orders .order-cards {
  display: none;
}

#orders .order-card {
  background: #fff;
  border-radius: 4px;
  border-width: 1px;
  border-style: solid;
  border-color: rgba(0, 0, 0, 0.12);
  margin-bottom: 16px;
  padding: 16px;

}

#orders .btn-danger, #orders .btn-success {
  border-radius: 100px;
}

@media (max-width: 768px) {
  #orders .order-cards {
    display: inline;
  }

  #orders .order-table {
    display: none;
  }
}

.order-filter-input {
  height: 26px;
}
</style>

<script>
import axios from 'axios'
//import Toast from '@/js/toast.min.js'
import LoginView from '@/views/LoginView.vue'
import {global} from "@/global.js";
  import ModalDialog from '@/components/ModalDialog.vue';
  import ModalActionDialog from '@/components/ModalActionDialog.vue';

export default {
  name: 'LkOrderView',
  components: {
    LoginView,
    ModalDialog,
    ModalActionDialog
  },
  data() {
    return {
      global: global,
      errored: false,
      loading: false,
      ordersFilter: {state: 0, text: "", date: null},
      orders: [],
      account: {subjects: []},
    }
  },

  mounted() {
    global.value.lk = true;
    if (global.value.authenticated) {
      this.load();
    } else {
      setTimeout(function () {
        if (global.value.authenticated) {
          this.load();
        }
      }.bind(this), 1000);
    }
  },


  methods: {
    load() {
      this.getAccount();
      this.loadOrders();
    },
    getAccount() {
      axios.get(global.value.url + "lk/account").then(response => {
        this.account = response.data;
        if (this.account.groups.length == 0) {
          this.$router.push("/setup");
        } else {
          if (document.getElementById("admin-booking-widget") != null) {
            document.getElementById("admin-booking-widget").remove();
          }
          if (document.getElementById("admin-booking-widget") == null) {
            var script = document.createElement('script');
            script.id = "admin-booking-widget";
            script.src = 'https://bookingeasy.ru/api/widget?type=1&mode=3&admin=true&key=' + this.account.key;
            document.head.appendChild(script);
          }
        }
      });
    },
    loadOrders() {
      this.loading = true;
      this.ordersFilter.page = 0;
      this.ordersFilter.size = 10;
      axios
          .get(global.value.url + "lk/order", {params: this.ordersFilter})
          .then(response => {
            this.orders = response.data;
            if (response.data.length == 10) {
              this.showAddOrdersBtn = true;
            } else {
              this.showAddOrdersBtn = false;
            }
            this.errored = false;
          })
          .catch(() => {
            this.errored = true;
          })
          .finally(() => (this.loading = false));
    },
    addOrders() {
      this.loading = true;
      this.ordersFilter.page = parseInt(this.orders.length / 10);
      this.ordersFilter.size = 10;
      var orders = this.orders;
      axios
          .get(global.value.url + "lk/order", {params: this.ordersFilter})
          .then(response => {
            response.data.forEach(function (item) {
              orders.push(item);
            });
            if (response.data.length == 10) {
              this.showAddOrdersBtn = true;
            } else {
              this.showAddOrdersBtn = false;
            }
            this.errored = false;
          })
          .catch(() => {
            this.errored = true;
          })
          .finally(() => (this.loading = false));
    },
    setState(order, state) {
      this.loading = true;
      axios
          .put(global.value.url + "lk/order", {"id": order, "state": state})
          .then(() => {
            this.loadOrders();
            this.errored = false;
          })
          .catch(() => {
            this.errored = true;
          })
          .finally(() => (this.loading = false));
    },
    cancelOrder(order) {
      this.loading = true;
      axios
      .post(global.value.url + "lk/cancel-pay-for-booking/"+order, {"id": order})
      .then(() => {
          this.loadOrders();
          this.errored = false;
        })
      .catch(() => {
          this.errored = true;
        })
      .finally(() => (this.loading = false));
    }
  }
}
</script>
